import { render, staticRenderFns } from "./import-driver.vue?vue&type=template&id=97abe20c&scoped=true&"
import script from "./import-driver.vue?vue&type=script&lang=js&"
export * from "./import-driver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97abe20c",
  null
  
)

export default component.exports